import {
  incPeriodIndex,
  decPeriodIndex,
  resetPeriodIndex,
  setFilter,
    setControls,
} from '../../../State/controls'
import { resetData } from '../../../State/data'
import { setScrollPosition } from '../../../State/scrollPosition'
import fetch from '../../../Services/fetch'

const saveScrollPosition = (dispatch) => {
  const scrollContainer = document.querySelector('.ant-table-body')
  if (scrollContainer) {
    const position = {
      scrollTop: scrollContainer.scrollTop,
      scrollLeft: scrollContainer.scrollLeft,
    }
    dispatch(setScrollPosition(position))
  }
}

export default (key, value) => (dispatch) => {

  switch (key) {

    case 'inc-period-index':
      saveScrollPosition(dispatch)
      dispatch(incPeriodIndex())
dispatch(resetData())
      dispatch(fetch())
      break

    case 'dec-period-index':
      saveScrollPosition(dispatch)
      dispatch(decPeriodIndex())
dispatch(resetData())
      dispatch(fetch())
      break

    case 'reset-period-index':
      saveScrollPosition(dispatch)
      dispatch(resetPeriodIndex())
dispatch(resetData())
      dispatch(fetch())
      break

    case 'yAxis':
      dispatch(setFilter({ key, value }))
      if (value !== 'map') {
        dispatch(resetData())
        dispatch(fetch())
      }
      break

    case 'summary':
      dispatch(setFilter({ key, value }))
      dispatch(resetData())
      dispatch(fetch())
      break

    case 'projectSearch':
    case 'subcontractorSearch':
    case 'shrink':
      dispatch(setFilter({ key, value }))
      break

    case 'ganttSettingDuration':
        dispatch(setFilter({ key, value }))
dispatch(resetData())

        dispatch(fetch())

    break

    default:
      dispatch(setFilter({ key, value }))
dispatch(resetData())
      dispatch(fetch())
      break

  }

}
